/* eslint-disable */
import * as React from 'react';
import { Link } from "gatsby"

import landingItem from "@modules/landingItem.module.css"

const ComponentItem = ({ children: compKey, CompType, Image, Title, Desc, URL}) => {
    const arrowIcon = require('@images/navigation/itemArrow.svg'); 
    let itemType;
    let itemProperty
    if(CompType === "" || CompType === null) {
        itemType = <span>View</span>
        itemProperty = " component"
        
    } else {
        itemType = <span>Learn about</span>
        itemProperty = " principle"
    }
    let imageGen;
    if(Image === "" || Image === null) {
        imageGen = null
    } else {
        imageGen = <img className={landingItem.image} src={Image} />
    }
    const linkText = Title.toLowerCase();

  return (
        <Link className={landingItem.anchor} to={URL}>
            <div className={landingItem.itemContainer + itemProperty}>
                    {imageGen}
                    <div className={landingItem.title}>{Title}</div>
                    <div className={landingItem.description}>{Desc}</div>
                    <div className={landingItem.link}>{itemType} {linkText} <span className={landingItem.icon}><img src={arrowIcon} alt="Arrow"/> </span></div>
            </div>
        </Link>
        )
    };
     
export default ComponentItem;







